import { NgModule } from 'ng-metadata/core';
import {AlertsModule} from './alerts/alerts.module';

@NgModule({
    declarations: [],
    providers: [
    ],
    imports:[
        AlertsModule
    ]
})
export class WidgetsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/widgets.module.ts